module.exports = __webpack_public_path__ + "img/QuotesAnimation.47653b89.gif";